var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.684,
    height: 24,
    viewBox: "0 0 24.684 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_25_invisible_px24",
    transform: "translate(0.342)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0 1.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,7S4,0,11,0,22,7,22,7s-4,7-11,7S0,7,0,7Z",
    transform: "translate(0 3)",
    fill: "rgba(0,0,0,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(7 6)",
    fill: "rgba(0,0,0,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,0,22,20",
    fill: "rgba(0,0,0,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.9
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInVisible);
export default __webpack_public_path__ + "static/media/InVisible.69ef9dd48094e4c40a94390dfb06081a.svg";
export { ForwardRef as ReactComponent };